import client from './client'
import type { ScheduleItem, ScheduleItemFormData } from '@/types/scheduleItems'

const base = (editionId: number): string =>
  `/organizer/editions/${editionId}/schedule-items`

export async function listScheduleItems(editionId: number): Promise<ScheduleItem[]> {
  const { data } = await client.get<{ data: ScheduleItem[] }>(base(editionId))
  return data.data
}

export async function createScheduleItem(
  editionId: number,
  payload: ScheduleItemFormData,
): Promise<ScheduleItem> {
  const { data } = await client.post<{ data: ScheduleItem }>(base(editionId), payload)
  return data.data
}

export async function updateScheduleItem(
  editionId: number,
  itemId: number,
  payload: Partial<ScheduleItemFormData>,
): Promise<ScheduleItem> {
  const { data } = await client.put<{ data: ScheduleItem }>(
    `${base(editionId)}/${itemId}`,
    payload,
  )
  return data.data
}

export async function deleteScheduleItem(editionId: number, itemId: number): Promise<void> {
  await client.delete(`${base(editionId)}/${itemId}`)
}
